

export const appEnum  ={
    dataType : {
        string:'string',
        number:'number',
        date:'date',
        datetime:'datetime',
        boolean:'boolean'
    },

    format :{
        int:'#,###',
        money:'#,###.00',
        date:'YYYY-MM-DD',
        datetime:'YYYY-MM-DD HH:mm:ss',
        minuteDate:'YYYY-MM-DD HH:mm'
    }
}





// WEBPACK FOOTER //
// ./src/utils/appEnum.ts